import { render, staticRenderFns } from "./MailAttachmentThumbnail.vue?vue&type=template&id=3b076a28&scoped=true"
import script from "./MailAttachmentThumbnail.vue?vue&type=script&lang=js"
export * from "./MailAttachmentThumbnail.vue?vue&type=script&lang=js"
import style0 from "./MailAttachmentThumbnail.vue?vue&type=style&index=0&id=3b076a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b076a28",
  null
  
)

export default component.exports